import { AdresaResponse } from './adresa-response';
import { KontaktResponse } from './kontakt-response';
import { PlneZneniePublicResponse } from './plne-znenie-public-response';
import { PrilohaResponse } from './priloha-response';
import { VyzvaPublicDynamickaSekcia } from './vyzva-public-dynamicka-sekcia';
import { VyzvaPublicUkazovatel } from './vyzva-public-ukazovatel';
import { VyzvaSprostredkovatelResponse } from './vyzva-sprostredkovatel-response';

/**
 * 
 * @export
 * @interface VyzvaPublicDetail
 */
export interface VyzvaPublicDetail {
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'ciel'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'dalsieNalezitostiVyzvy'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'dalsiePodmienkyPoskytnutiaProstriedkov'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'dalsiePodmienkyZOsobitnychPredpisov'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'datumCasUzavretia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'datumVyhlasenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'dovodUzatvorenia'?: VyzvaPublicDetailDovodUzatvoreniaEnum;
    /**
     * 
     * @type {Array<VyzvaPublicDynamickaSekcia>}
     * @memberof VyzvaPublicDetail
     */
    'dynamickeSekcie'?: Array<VyzvaPublicDynamickaSekcia>;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'ineFormalneNalezitosti'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'ineObsahoveNalezitosti'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'inyDovodUzatvorenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'komponent'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'kriteriaHodnoteniaZoPPM'?: string;
    /**
     * 
     * @type {number}
     * @memberof VyzvaPublicDetail
     */
    'mieraSpolufinancovania'?: number;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'mieraSpolufinancovaniaUpresnenie'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'miestoPodaniaZoPPM'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'oblast'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'opatrenie'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'opravneniZiadatelia'?: string;
    /**
     * 
     * @type {PlneZneniePublicResponse}
     * @memberof VyzvaPublicDetail
     */
    'plneZnenie'?: PlneZneniePublicResponse;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'podmienkyDoruceniaZiadosti'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'podmienkyOpravnenostiZiadatela'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'podmienkyStatnejPomoci'?: string;
    /**
     * 
     * @type {Array<PrilohaResponse>}
     * @memberof VyzvaPublicDetail
     */
    'prilohaResponses'?: Array<PrilohaResponse>;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'sposobHodnoteniaZoPPM'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'sposobKomunikacie'?: string;
    /**
     * 
     * @type {Array<VyzvaSprostredkovatelResponse>}
     * @memberof VyzvaPublicDetail
     */
    'sprostredkovatelia'?: Array<VyzvaSprostredkovatelResponse>;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'stav'?: VyzvaPublicDetailStavEnum;
    /**
     * 
     * @type {number}
     * @memberof VyzvaPublicDetail
     */
    'sumOpravneneVydavkyMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof VyzvaPublicDetail
     */
    'sumOpravneneVydavkyMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof VyzvaPublicDetail
     */
    'sumVyskaProstriedkov'?: number;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'ucelPouzitiaProstriedkov'?: string;
    /**
     * 
     * @type {Array<VyzvaPublicUkazovatel>}
     * @memberof VyzvaPublicDetail
     */
    'ukazovatelList'?: Array<VyzvaPublicUkazovatel>;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'uzavretieText'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'vyhlasenaNaZaklade'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'vyhlasovatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'vykonavatel'?: string;
    /**
     * 
     * @type {AdresaResponse}
     * @memberof VyzvaPublicDetail
     */
    'vykonavatelAdresa'?: AdresaResponse;
    /**
     * 
     * @type {KontaktResponse}
     * @memberof VyzvaPublicDetail
     */
    'vykonavatelKontakt'?: KontaktResponse;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'zoppmPodanieDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicDetail
     */
    'zoppmPodanieOd'?: string;
}

export const VyzvaPublicDetailDovodUzatvoreniaEnum = {
    VycerpanePenazneProstriedky: 'VYCERPANE_PENAZNE_PROSTRIEDKY',
    DosiahnutyCasovyHorizont: 'DOSIAHNUTY_CASOVY_HORIZONT',
    Ine: 'INE'
} as const;

export type VyzvaPublicDetailDovodUzatvoreniaEnum = typeof VyzvaPublicDetailDovodUzatvoreniaEnum[keyof typeof VyzvaPublicDetailDovodUzatvoreniaEnum];
export const VyzvaPublicDetailStavEnum = {
    Nova: 'NOVA',
    Planovana: 'PLANOVANA',
    VPriprave: 'V_PRIPRAVE',
    KontrolaNika: 'KONTROLA_NIKA',
    NaDoplnenie: 'NA_DOPLNENIE',
    KontrolaUkoncena: 'KONTROLA_UKONCENA',
    Zverejnena: 'ZVEREJNENA',
    Pozastavena: 'POZASTAVENA',
    Uzatvorena: 'UZATVORENA',
    Vyhodnotena: 'VYHODNOTENA',
    RegistraciaZrusena: 'REGISTRACIA_ZRUSENA',
    Zrusena: 'ZRUSENA',
    PredPodpisomZmluvy: 'PRED_PODPISOM_ZMLUVY',
    ZmluvaUzavreta: 'ZMLUVA_UZAVRETA'
} as const;

export type VyzvaPublicDetailStavEnum = typeof VyzvaPublicDetailStavEnum[keyof typeof VyzvaPublicDetailStavEnum];


